import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import isNil from 'lodash/isNil'
import Button from '@vtex/styleguide/lib/Button'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import toastWebHookNotification from '@/checkout-instore-legacy/components/Commons/WebHook/toastWebHookNotification'
import { FISCAL_CODE_MESSAGES } from '@/checkout-instore-legacy/constants/PrintConstants'
import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'
import { withMediaQuery } from '@/checkout-instore-legacy/utils/mediaQuery'
import { shouldPrintOrder } from '@/checkout-instore-legacy/utils/printUtils'

import InvoiceHook from '../InvoiceHook'

const PRINT_RETRIES = 1

class PrintDetails extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      forcePrint: false,
    }
    this.webHook = React.createRef()
  }

  rePrint() {
    if (this.webHook.current) {
      this.webHook.current.resendHookRequest()
    } else {
      this.setState({
        forcePrint: true,
      })
    }
  }

  getPrintImmediately() {
    const { orderPlacedHook: orderPlacedHookValue } = getInstoreConfig()
    return !isNil(orderPlacedHookValue.printImmediately)
      ? orderPlacedHookValue.printImmediately
      : this.props.printImmediately
  }

  render() {
    const { order, alreadyCalledHook, intl, device, mediaQuery } = this.props
    const { forcePrint } = this.state
    const printImmediately = this.getPrintImmediately()

    const hasOrderPlacedHook = shouldPrintOrder(order)
    const printFiscal =
      printImmediately || alreadyCalledHook ? (
        <FormattedMessage id="orderPlacedReprintFiscalNote" />
      ) : (
        <FormattedMessage id="orderPlacedPrintFiscalNote" />
      )

    const buttonSize = mediaQuery({
      phone: 'small',
      tablet: 'regular',
    })

    const fullWidth = mediaQuery({
      phone: true,
      tablet: true,
      desktop: false,
    })

    return (
      hasOrderPlacedHook && (
        <div className="print-details no-print">
          <Button
            id="print-details-reprint"
            variation="tertiary"
            size={buttonSize}
            block={fullWidth}
            onClick={() => this.rePrint()}
          >
            {printFiscal}
          </Button>
          <InvoiceHook
            ref={this.webHook}
            sendImmediately={!alreadyCalledHook || forcePrint}
            retries={PRINT_RETRIES}
            order={order}
            device={device}
            errorNodeSelector={`#print-details-error-${order.orderId}`}
            messages={FISCAL_CODE_MESSAGES(intl)}
          >
            {toastWebHookNotification}
          </InvoiceHook>
        </div>
      )
    )
  }
}

PrintDetails.defaultProps = {
  printImmediately: true,
  alreadyCalledHook: false,
}

PrintDetails.propTypes = {
  order: PropTypes.shape({
    orderId: PropTypes.string.isRequired,
  }),
  printImmediately: PropTypes.bool,
  alreadyCalledHook: PropTypes.bool,
  intl: intlShape.isRequired,
  mediaQuery: PropTypes.func,
  device: PropTypes.shape({
    deviceId: PropTypes.string.isRequired,
    deviceName: PropTypes.string.isRequired,
  }),
}

export default injectIntl(withMediaQuery(PrintDetails))
